import React from 'react';
import { X, Delete, Minus, Plus, Divide } from 'react-feather';
import Equals from '../../../assets/img/svg/equals-solid.svg';
export default class ButtonPanel extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick = (event) => {
        var target = event.currentTarget;
        this.props.onClick(target.dataset.value);
    };

    componentDidMount() {
        var buttons = document.querySelectorAll('.react-calc button');

        buttons = [].slice.call(buttons);
        const keyMapping = {};
        buttons.forEach((button) => {
            keyMapping[button.dataset.code] = button;
        });

        this.props.onLoad(keyMapping);
    }

    render() {
        return (
            <div className="react-calc container button button-panel d-block">
                <div className="row">
                    <div className="col-6 col-6 col-sm-6 col-md-6 col-lg-6 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 rounded-0"
                            data-code="67"
                            data-value="c"
                            onClick={this.onClick}
                        >
                            C
                        </button>
                    </div>
                    <div className="col-3 col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="8"
                            data-value="back"
                            onClick={this.onClick}
                        >
                            {/* <ArrowLeft size="14" className="calc-dark-icon" /> */}
                            <Delete size="14" className="calc-dark-icon" />
                        </button>
                    </div>
                    {/* <div className="col-3 col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="190"
                            data-value="."
                            onClick={this.props.onEraseClick}
                        >
                            <Delete size="14" className="calc-dark-icon" />
                        </button>
                    </div> */}

                    <div className="col-3 col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 primary-btn"
                            data-code="shift+56"
                            data-value="*"
                            onClick={this.onClick}
                        >
                            <X size="14" strokeWidth="3" className="calc-white-icon" />
                        </button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="55"
                            data-value="7"
                            onClick={this.onClick}
                        >
                            7
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="56"
                            data-value="8"
                            onClick={this.onClick}
                        >
                            8
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="57"
                            data-value="9"
                            onClick={this.onClick}
                        >
                            9
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 primary-btn"
                            data-code="189"
                            data-value="-"
                            onClick={this.onClick}
                        >
                            <Minus size="14" strokeWidth="3" className="calc-white-icon" />
                        </button>
                    </div>
                </div>

                <div className=" row">
                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="52"
                            data-value="4"
                            onClick={this.onClick}
                        >
                            4
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="53"
                            data-value="5"
                            onClick={this.onClick}
                        >
                            5
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="54"
                            data-value="6"
                            onClick={this.onClick}
                        >
                            6
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 primary-btn"
                            data-code="shift+187"
                            data-value="+"
                            onClick={this.onClick}
                        >
                            <Plus size="14" strokeWidth="3" className="calc-white-icon" />
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="49"
                            data-value="1"
                            onClick={this.onClick}
                        >
                            1
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="50"
                            data-value="2"
                            onClick={this.onClick}
                        >
                            2
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0"
                            data-code="51"
                            data-value="3"
                            onClick={this.onClick}
                        >
                            3
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 primary-btn"
                            data-code="191"
                            data-value="/"
                            onClick={this.onClick}
                        >
                            <Divide size="14" strokeWidth="2.5" className="calc-white-icon" />
                        </button>
                    </div>
                </div>

                <div className="row">
                    <div
                        className={`${
                            this.props.discountWrapper
                                ? 'col-3 col-sm-3 col-md-3 col-lg-3'
                                : `col-6 col-sm-6 col-md-6 col-lg-6`
                        } px-0`}
                    >
                        <button
                            className="btn btn-sm light-btn h-100 w-100 rounded-0"
                            data-code="48"
                            data-value="0"
                            onClick={this.onClick}
                        >
                            0
                        </button>
                    </div>
                    {this.props.discountWrapper && (
                        <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                            <button
                                className="btn btn-sm light-btn h-100 w-100 rounded-0"
                                data-code="190"
                                data-value="."
                                onClick={this.onClick}
                            >
                                .
                            </button>
                        </div>
                    )}

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100 w-100 rounded-0"
                            disabled={this.props.noOfCartonWrapper ? (!this.props.cur ? false : false) : false}
                            onClick={this.props.onOkClick}
                        >
                            Ok
                        </button>
                    </div>

                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 px-0">
                        <button
                            className="btn btn-sm light-btn h-100  w-100 rounded-0 primary-btn"
                            data-code="13"
                            data-value="="
                            onClick={this.onClick}
                        >
                            <img src={Equals} height="10" width="10" alt="" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
